var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0738 0H0.926085C0.600034 0 0.341284 0.243068 0.292278 0.556051L5.49995 3.9871L10.7076 0.556051C10.6586 0.243068 10.3999 0 10.0738 0ZM0.272701 5.87529V1.32495L3.79719 3.64717L0.272701 5.87529ZM10.7273 5.87529L7.20277 3.64717L10.7273 1.32495V5.87529ZM5.67968 4.65089L6.60425 4.04191L10.7064 6.63595C10.656 6.94632 10.3986 7.18743 10.0739 7.18743H0.926121C0.601377 7.18743 0.343934 6.94632 0.293621 6.63595L4.39573 4.04126L5.3203 4.65089C5.37519 4.68683 5.43726 4.70447 5.49999 4.70447C5.56271 4.70447 5.62479 4.68683 5.67968 4.65089Z",
    fill: "#FF7B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.8ef062a2fb58e0517143dbdb48abf076.svg";
export { ForwardRef as ReactComponent };